<template>
  <b-form-timepicker
    :id="id"
    ref="time-picker"
    v-model="val"
    :state="state"
    :name="name"
    v-bind="{
      isRTL: true,
      labelHours: 'ساعت',
      labelMinutes: 'دقیقه',
      labelSeconds: 'ثانیه',
      labelAmpm: 'صبح یا عصر',
      labelAm: 'ص',
      labelPm: 'ع',
      labelIncrement: 'افزایش',
      labelDecrement: 'کاهش',
      labelSelected: 'انتخاب زمان',
      labelNoTimeSelected: '',
      labelCloseButton: 'بستن',
    }"
    locale="fa"
    menu-class="custom-timePicker"
    @context="$emit('input', $event.value)"
  />
</template>

<script>

import { BFormTimepicker } from 'bootstrap-vue'

export default {
  name: 'ZFormTimepicker',
  components: {
    BFormTimepicker,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
    val(v) {
      this.$emit('input', v)
    },
  },
}
</script>
